import { Link } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import '../../app_structure/truyen.css';
import { alert_error, alert_success } from '../../AppContext';
import { RingLoader } from "react-spinners";
import axios from "axios";
function Truyentranhhome() {
  const [datahome, setdatahome] = useState(null);
  useEffect(() => {
    axios.get("https://tecom.pro/giai-tri/truyen-tranh/the-loai/home.php")
      .then((response) => {
        if (response.data.status != 1 && response.data.message != '') {
          alert_error(response.data.message);
          //   chuyenhuong(response.data);
        } else {
          setdatahome(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <>
      <head>
        <meta charset="UTF-8" />
        <title>Đọc truyện tranh</title>
        <meta name="description" content="Đọc truyện miễn phí Hust Media" />
        <meta name="keywords" content="đọc truyện, đọc truyện tranh, hust media" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </head>
      <div className="max-w-2xl px-1 py-4 mx-auto rounded-lg shadow-xl">
        <div className="text-center">
          Đọc truyện tranh là một tính năng níu kéo người dùng ở App nếu có vấn đề bản quyền và pháp lý vui lòng liên hệ zalo hoặc số điện thoại 0367776906 chúng tôi sẽ gỡ truyện ngay lập tức
          <br />
        </div>
        <div className="col">
          {datahome ?
            (<div className="fixrow row text-center">
              {datahome.links.map((link, index) => (
                <Link style={{ textDecoration: 'none' }} to={link.to} className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-3 w-auto dark:bg-slate-800 dark:text-white" key={index}>
                  <div className="m-auto">
                    <div className="flex items-center justify-start flex-1 space-x-4">
                      <span className="font-medium px-2 text-lg">{link.text}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            )
            : (
              <div className="flex justify-center items-center ">
                <RingLoader size={80} color="#0000ff" />  </div>
            )}
        </div>
      </div>
    </>
  );
}
export default Truyentranhhome;